<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="editMode()">{{ t('common.labels.partner') }} <strong>{{ partner.name }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView>

        <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h">
          <app-partner-basedata *ngIf="editMode()" [partner]="partner"></app-partner-basedata>
        </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
